import { useMemo, useState } from "react";

export function useTableTools(rows, searchKeys) {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(() => new Set());

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return rows;
    const keys = searchKeys && searchKeys.length ? searchKeys : Object.keys(rows[0] || {});
    return rows.filter((r) =>
      keys.some((k) => {
        const v = r[k];
        return v != null && String(v).toLowerCase().includes(q);
      })
    );
  }, [rows, query, searchKeys]);

  const toggle = (id) =>
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const selectAllVisible = () =>
    setSelected(new Set(filtered.map((r) => r.id)));

  const clear = () => setSelected(new Set());

  const allVisibleSelected = filtered.length > 0 && filtered.every((r) => selected.has(r.id));
  const selectedRows = rows.filter((r) => selected.has(r.id));

  return { query, setQuery, filtered, selected, toggle, selectAllVisible, clear, allVisibleSelected, selectedRows };
}
